import {get, put, post, del, default as com} from '@/common/api'

const api = {
  saveChannel:(para)=>{
    if (para.id) {
      return put(`/api/op/regChannel/${para.id}`, para)
    } else {
      return post('/api/op/regChannel', para)
    }
  },
  delChannel:(id)=>{
    return del(`/api/op/regChannel/${id}`)
  },
  queryChannels: com.queryChannel
  ,
  getChannel:(id)=>{
    return get(`/api/op/regChannel/${id}`)
  }
}

export default api
